import {
    UPDATE_BLEMISH_REPORT_REQUEST,
    UPDATE_BLEMISH_REPORT_SUCCESS,
    UPDATE_BLEMISH_REPORT_FAILURE,
} from '../../constants/questions_constants/update_blemish_report.constants';

export const updateBlemishReportRequest = (params, params2) => ({
    type: UPDATE_BLEMISH_REPORT_REQUEST,
    params,
    params2,
});

export const updateBlemishReportSuccess = payload => ({
    type: UPDATE_BLEMISH_REPORT_SUCCESS,
    payload,
});

export const updateBlemishReportFailure = error => ({
    type: UPDATE_BLEMISH_REPORT_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/questions_actions/update_blemish_report.actions.js